import { Grid } from '@mui/material';
import { AdvertiserField } from '../../components/AdvertiserField';
import { CampaignField } from '../../components/CampaignField';
import { OrderField } from '../../components/OrderField';
import { VersionField } from '../../components/VersionField';

/**
 * Shared advertiser / campaign / version / order filter fields for schedule listings.
 */
export function ScheduleMetadataFilterFields() {
  return (
    <>
      <Grid item xs={12} md={3} lg={2} xl={2}>
        <AdvertiserField />
      </Grid>
      <Grid item xs={12} md={3} lg={2} xl={2}>
        <CampaignField />
      </Grid>
      <Grid item xs={12} md={3} lg={2} xl={2}>
        <VersionField />
      </Grid>
      <Grid item xs={12} md={3} lg={2} xl={2}>
        <OrderField />
      </Grid>
    </>
  );
}
